






















    import {Vue, Component, Prop, Watch} from "vue-property-decorator";

	@Component({})
	export default class SliderControl extends Vue{
	    @Prop()
		size: number;

	    @Prop()
		active: number;

	    @Watch("active")
		activeTabHandler(){
	        if(this.active){
                this.activeTab = this.active;
            }
		}

	    private activeTab: number = 0;

	    setSlide(index: number){
	        if(index > this.size){
	            this.activeTab = this.size;
	            return;
			}

	        this.activeTab = index;

	        this.$emit("change", this.activeTab);
		}

	}
